import { render, staticRenderFns } from "./shipAuth.vue?vue&type=template&id=ac6c5f4a&scoped=true&"
import script from "./shipAuth.vue?vue&type=script&lang=js&"
export * from "./shipAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6c5f4a",
  null
  
)

export default component.exports